<p class="errormessage" >**Login OTP has been sent to your email id.</p>

<div class="otp-container">
  <!-- <input 
    *ngFor="let item of otpArray; let i = index"
    type="text"
    maxlength="1"
  [ngClass]="otpinputclass"    [(ngModel)]="otp[i]"
    (input)="onInput($event, i)"
    (keydown)="onKeyDown($event, i)"
     (paste)="onPaste($event)"
  /> -->
  <div class="grid">
 <div class="col-8">
  <label for="otp" class="required-label">OTP <span>*</span></label>
  <input type="text" class="form-control"  [(ngModel)]="otp" placeholder="Enter OTP">
    <span class="invaliderror" *ngIf="ivalidotp">OTP is invalid. Please try again!</span>

 </div>
  </div>


</div>



 <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="onclose()"></p-button>

        <p-button class="m-1" label="Verify OTP" styleClass="customesave" (click)="verifyOTP()">
        </p-button>
    </div>

